import { Cabin, CabinTypeTranslation, Departure } from '../data.ts'
import { useTranslation } from 'react-i18next'
import { CabinBlock } from './cabin-block.tsx'
import { CabinSelection } from '../types/cabin-selection.ts'
import { useMemo } from 'react'

export function CabinList ({
  departure,
  cabinSelection,
  addCabin,
  removeCabin,
  setCabinAmount,
  cabinTypeTranslations = []
}: {
  departure: Departure
  cabinSelection: CabinSelection
  addCabin: (cabin: Cabin) => void
  removeCabin: (cabinId: string) => void
  setCabinAmount: (id: string, amount: number) => void
  cabinTypeTranslations?: CabinTypeTranslation[]
}): JSX.Element {
  const { t } = useTranslation('widget')
  const shipTranslations = useMemo(() => cabinTypeTranslations.filter(translation => translation.ship_id === departure.ship.id), [cabinTypeTranslations, departure.ship.id])

  return (
    <div>
      <h2 className='font-bold text-brand-primary mb-4'>{t('select_available_cabins', 'Select available cabins')}</h2>
      <div className='grid grid-cols-1 gap-4 @desktop:grid-cols-[15rem_1fr_auto]'>
        {
          departure.cabins.map((cabin) => (
            <CabinBlock
              key={cabin.unit_price} cabin={cabin}
              cabinTypeTranslations={shipTranslations}
              cabinSelection={cabinSelection}
              addCabin={addCabin}
              removeCabin={removeCabin}
              setCabinAmount={setCabinAmount}
              discount={departure.discount}
            />
          ))
        }
      </div>
    </div>
  )
}
